"use client";

import { GlowButton } from "@/apps/charm/components/marketing/glow-button";
import { useGsapReveal } from "@/apps/charm/components/marketing/use-gsap";

interface DarkCTAProps {
  headline: string;
  buttonText: string;
  href?: string;
  subtext?: string;
}

export function DarkCTA(props: DarkCTAProps) {
  const ref = useGsapReveal();

  return (
    <section className="v2-light-alt-textured">
      <div
        ref={ref}
        className="mx-auto flex max-w-6xl flex-col items-center gap-8 px-6 py-24 md:px-10 md:py-36">
        <h2 className="max-w-xl text-center font-heading text-4xl font-normal text-v2-text md:text-5xl">
          {props.headline}
        </h2>

        <GlowButton href={props.href}>{props.buttonText}</GlowButton>

        {props.subtext && (
          <p className="font-mono text-[11px] uppercase tracking-[2px] text-v2-text-faint">
            {props.subtext}
          </p>
        )}
      </div>
    </section>
  );
}
